import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useTranslation } from 'react-i18next';
import {
  createOpenAccountSchema,
  type OpenAccountFormValues,
} from './openAccountSchema';

const useOpenAccountForm = (formFields: Array<string>) => {
  const { t } = useTranslation();
  const schema = createOpenAccountSchema(t, formFields);

  const defaultValues: Record<string, string | boolean> = {};

  formFields.forEach(field => {
    if (field === 'eula') {
      defaultValues[field] = false;
    } else {
      defaultValues[field] = '';
    }
  });

  const form = useForm<OpenAccountFormValues>({
    mode: 'onChange',
    resolver: zodResolver(schema),
    defaultValues: {
      ...defaultValues,
    },
  });

  return {
    form,
  };
};

export { useOpenAccountForm };
